export default __webpack_public_path__ + "static/media/753.919e3df9.gif";